import { FormEvent, useState } from 'react'
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { setSuperAdminToken } from '../helpers'

export default function SuperAdminLogin() {
  const navigate = useNavigate()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [errorText, setErrorText] = useState('')

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setErrorText('')

    try {
      setLoading(true)
      const response = await fetch(`${process.env.REACT_APP_API_URL}/super-admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      })

      const body = await response.json()

      if (body?.stage === 'pin_required' && body?.pendingToken) {
        navigate(`/super-admin/pincode-validation/${encodeURIComponent(body.pendingToken)}`)
        return
      }

      if (!response.ok || !body?.token) {
        setErrorText('Login failed. Check credentials.')
        return
      }

      setSuperAdminToken(body.token)
      navigate('/super-admin')
    } catch {
      setErrorText('Network error.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Container className='py-5'>
      <Row className='justify-content-center'>
        <Col md={6} lg={4}>
          <Card>
            <Card.Body>
              <h4 className='mb-3'>Super Admin</h4>
              <Form onSubmit={handleSubmit}>
                <Form.Group className='mb-3'>
                  <Form.Label>Username</Form.Label>
                  <Form.Control
                    value={username}
                    onChange={e => setUsername(e.target.value)}
                    autoComplete='username'
                  />
                </Form.Group>

                <Form.Group className='mb-3'>
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type='password'
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    autoComplete='current-password'
                  />
                </Form.Group>

                {!!errorText && <p className='text-danger mb-3'>{errorText}</p>}

                <Button type='submit' disabled={loading}>
                  {loading ? 'Logging in...' : 'Login'}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}
